import Vue from 'vue'

Vue.mixin({
    methods: {
        clientId() {
            return this.$auth.user().company_id;
        },
        isAdmin() {
            return this.$auth.check({type: 'admin'});
        },
        canChangeMasterEntity(clientId) {
            return this.isAdmin() || this.clientId() === clientId;
        },
        getCurrencyByCode(code) {
            // currencies between gbp, eur, usd
            const currencies = [
                { code: 'GBP', name: 'British Pound', symbol: '£' },
                { code: 'EUR', name: 'Euro', symbol: '€' },
                { code: 'USD', name: 'US Dollar', symbol: '$' }
            ];
            // find currency by code
            const currency = currencies.find(c => c.code === code);
            // return currency or null if not found
            return currency || null;
            }
        }
});
